export const graphQLURL = 'https://api-useast.graphcms.com/v1/cjj8np818014v01ccyrg0hlho/master?'
export const graphQLToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ2ZXJzaW9uIjoxLCJ0b2tlbklkIjoiYjIxOGU3YTMtYWRhMy00YzEzLTljMmItMmZmNDljMDVhNWNkIn0.uJvvv73HHkqN_OYgfGeaxfQO2hJb07V6o9LfbU44LwU'

export const getCookie = (name) => {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export const restApiEndpoint = () => {
  return getCookie('operationApi') || (process.env.REACT_APP_DOMAIN === 'tools' ? 'https://operations.optionsedu.com/api' : 'https://operationsbeta.optionsedu.com/api');
}

export const setCookie = (name, value, days) => {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

export const deleteCookie = (name) => { setCookie(name, '', -1); }

export const getAuthHeaders = () => {
  return {
      'Authorization': `Bearer ${localStorage.getItem('id_token')}`,
      'Content-Type': 'application/json'
  }
}

export const numberFormatter = (nStr) => {
    try {
      nStr = parseFloat(nStr).toFixed(2);
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        //eslint-disable-next-line
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    } catch (err) {
      return nStr
    }
}

export const isJson = (jsonData) => {
  try {
    const data = JSON.parse(jsonData);
    return true;
  } catch(err) {
    return false;
  }
}

export const getQueryString = function ( field, url ) {
  let href = url ? url : window.location.href;
  let reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
  let string = reg.exec(href);
  return string ? string[1] : null;
};

export const tradeTransHeaders = (access) => {
  let accessList = ['TradeDate', 'Action', 'AssetType', 'Underlying', 'Quantity', 'Expiration', 'Strike', 'Price', 'Commission', 'Multiplier']
  if(access) {
    accessList.push('Actions')
  }
  return accessList
}

export const transactionsTreeData = (access) => {
  let array = [
    {
      title: 'Date',
      value: 'TradeDate',
      key: 'TradeDate'
    },
    {
      title: 'Action',
      value: 'Action',
      key: 'Action'
    },
    {
      title: 'Type',
      value: 'AssetType',
      key: 'AssetType'
    },
    {
      title: 'Underlying',
      value: 'Underlying',
      key: 'Underlying'
    },
    {
      title: 'Qty',
      value: 'Quantity',
      key: 'Quantity'
    },
    {
      title: 'Exp Date',
      value: 'Expiration',
      key: 'Expiration'
    },
    {
      title: 'Strike',
      value: 'Strike',
      key: 'Strike'
    },
    {
      title: 'Price',
      value: 'Price',
      key: 'Price'
    },
    {
      title: 'Commission',
      value: 'Commission',
      key: 'Commission'
    },
    {
      title: 'Multiplier',
      value: 'Multiplier',
      key: 'Multiplier'
    },
    {
      title: 'UnderlyingPrice',
      value: 'UnderlyingPrice',
      key: 'UnderlyingPrice'
    },
    {
      title: 'Mark',
      value: 'Mark',
      key: 'Mark'
    },
    {
      title: 'Group',
      value: 'TransactionGroup',
      key: 'TransactionGroup'
    },
  ];

  if(access) {
    array.push({
      title: 'Actions',
      value: 'Actions',
      key: 'Actions'
    })
  }
  return array
}

export const tradePositionsHeaders = (access) => {
  return ['Instrument', 'OpenDate', 'CloseDate', 'Quantity', 'AveragePrice', 'Price', 'Delta', 'Gamma', 'Theta', 'Vega', 'ImpliedVolatility', 'DaysToExpire', 'PlOpen', 'PlClosed']
}

export const positionsTreeData = (access) => {
  return [
    {
      title: 'Instrument',
      value: 'Instrument',
      key: 'Instrument'
    },
    {
      title: 'Open Date',
      value: 'OpenDate',
      key: 'OpenDate'
    },
    {
      title: 'Close Date',
      value: 'CloseDate',
      key: 'CloseDate'
    },
    {
      title: 'Qty',
      value: 'Quantity',
      key: 'Quantity'
    },
    {
      title: 'Avg Price',
      value: 'AveragePrice',
      key: 'AveragePrice'
    },
    {
      title: 'Price',
      value: 'Price',
      key: 'Price'
    },
    {
      title: 'Delta',
      value: 'Delta',
      key: 'Delta'
    },
    {
      title: 'Gamma',
      value: 'Gamma',
      key: 'Gamma'
    },
    {
      title: 'Theta',
      value: 'Theta',
      key: 'Theta'
    },
    {
      title: 'Vega',
      value: 'Vega',
      key: 'Vega'
    },
    {
      title: 'IV',
      value: 'ImpliedVolatility',
      key: 'ImpliedVolatility'
    },
    {
      title: 'Days to Expire',
      value: 'DaysToExpire',
      key: 'DaysToExpire'
    },
    {
      title: 'P/L Open',
      value: 'PlOpen',
      key: 'PlOpen'
    },
    {
      title: 'P/L Closed',
      value: 'PlClosed',
      key: 'PlClosed'
    },
  ];
}


// WEBPACK FOOTER //
// ./src/utils/common.js